import type { RouteObject } from "react-router";
import { InsightsFreigabe } from "./InsightsFreigabe";
import { LinkAbgelaufen } from "./LinkAbgelaufen";
import { Freigabe } from "./Freigabe";
import { Bericht } from "./Bericht";
import { KitFreigabe } from "./KitFreigabe";
import { Datenloeschung } from "./Datenloeschung";

/**
 * Öffentliche Seiten ohne Anmeldung (Insights-Freigabe, 0073: Freigabe-Link und Bericht für die Marke, 0074: Media-Kit,
 * abgelaufene Links, 0156: Stand eines Löschwunschs über Meta). Vertragsunterschrift: pages/unterschreiben.
 */
export const oeffentlichRoutes: RouteObject[] = [
  { path: "/i/:token", element: <InsightsFreigabe /> },
  { path: "/freigabe/:token", element: <Freigabe /> },
  { path: "/bericht/:token", element: <Bericht /> },
  { path: "/kit/:token", element: <KitFreigabe /> },
  { path: "/abgelaufen", element: <LinkAbgelaufen /> },
  { path: "/datenloeschung", element: <Datenloeschung /> },
];
